/* PLEYNE — About scroll storytelling. Self-scoping: runs for each .about-root on the page.
   Loaded only when motion is enabled (the section wraps the <script src> in {% unless disable_motion %}). */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

  function esc(t){ return t.replace(/&/g,'&amp;').replace(/[<]/g,'&lt;'); }
  var CLOSE = '<' + '/span>'; // avoid a literal closing tag in source

  function initRoot(root){
    var page = root.classList.contains('page') ? root : root.querySelector('.page');
    if (!page) page = root;
    page.classList.add('anim-ready');

    // movements + stats: staggered reveal on enter
    var groups = [].slice.call(root.querySelectorAll('.mv-grid, .stats'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.2 });
      groups.forEach(function(g){ io.observe(g); });
    } else {
      groups.forEach(function(g){ g.classList.add('in'); });
    }

    // split each heading into words
    root.querySelectorAll('.copy-col h2[data-h]').forEach(function(h){
      var txt = h.textContent.trim();
      h.setAttribute('aria-label', txt);
      h.innerHTML = txt.split(/\s+/).map(function(w){ return '<span class="w">' + esc(w) + CLOSE; }).join(' ');
    });

    // split plain body paragraphs into sentences (skip paragraphs with inline formatting)
    root.querySelectorAll('.copy-body p').forEach(function(p){
      if (p.children.length) return;
      var parts = p.textContent.match(/[^.!?]+[.!?]*\s*/g);
      if (!parts || parts.length < 2) return;
      p.innerHTML = parts.map(function(s){ return '<span class="s">' + esc(s) + CLOSE; }).join('');
      p.style.opacity = '1'; p.style.transform = 'none'; // container visible; the .s sentences animate
    });

    if (!window.matchMedia('(min-width:769px)').matches) {
      // MOBILE: reveal each chapter's words + units as it scrolls into view (scroll-based, robust)
      var revealChap = function(ch){
        if (ch._rv) return; ch._rv = true;
        [].slice.call(ch.querySelectorAll('.copy-col h2 .w')).forEach(function(w,i){
          w.style.transitionDelay = (i * 0.05).toFixed(2) + 's'; w.classList.add('rv');
        });
        var units = [];
        ch.querySelectorAll('.copy-body p').forEach(function(p){
          var ss = p.querySelectorAll('.s');
          if (ss.length){ [].push.apply(units, [].slice.call(ss)); } else { units.push(p); }
        });
        var q = ch.querySelector('.copy-col .quote'); if (q) units.push(q);
        var f = ch.querySelector('.chap-fig'); if (f) units.push(f);
        units.forEach(function(u,i){ u.style.transitionDelay = (0.12 + i * 0.08).toFixed(2) + 's'; u.classList.add('rv'); });
      };
      var mchaps = [].slice.call(root.querySelectorAll('[data-chap]'));
      var checkReveal = function(){
        var vh = window.innerHeight;
        for (var k = 0; k < mchaps.length; k++){
          var ch = mchaps[k]; if (ch._rv) continue;
          var r = ch.getBoundingClientRect();
          if (r.top < vh * 0.85 && r.bottom > 0) revealChap(ch);
        }
      };
      checkReveal();
      window.addEventListener('scroll', checkReveal, { passive: true });
      window.addEventListener('resize', checkReveal, { passive: true });
      return;
    }

    var chaps = [].slice.call(root.querySelectorAll('[data-chap]'));
    chaps.forEach(function(ch){
      var units = [];
      ch.querySelectorAll('.copy-body p').forEach(function(p){
        var ss = p.querySelectorAll('.s');
        if (ss.length){ [].push.apply(units, [].slice.call(ss)); } else { units.push(p); }
      });
      var q = ch.querySelector('.copy-col .quote'); if (q) units.push(q);
      var f = ch.querySelector('.chap-fig'); if (f) units.push(f);
      ch._units = units;
      ch._words = [].slice.call(ch.querySelectorAll('.copy-col h2 .w'));
      ch._in = ch.querySelector('.chap-in');
      ch._stage = ch.querySelector('.chap-stage');
    });

    // the founders photo pinned beside the whole story: it rises in with Chapter I, stays (same size, same shape)
    // while every chapter is read, and settles slowly over the whole story
    var story = root.querySelector('.story');
    var side = root.querySelector('.story-side .about-portrait'), sBox, sImg, sCap;
    if (side){
      side.classList.add('pv-scrub');
      sBox = side.querySelector('.about-portrait-img');
      sImg = side.querySelector('img');
      sCap = side.querySelector('figcaption');
    }

    // The pinned stage sits below the fixed header: the stage is padded by the header's height (CSS reads --chap-hdr),
    // and a chapter taller than the room left glides up as it is read, so its heading never starts under the header.
    var header = document.getElementById('header') || document.querySelector('.site-header');
    var hdr = 0, PAD = 24;
    function measure(){
      hdr = header ? header.offsetHeight : 0;
      root.style.setProperty('--chap-hdr', hdr + 'px');
      chaps.forEach(function(ch){ ch._h = ch._in ? ch._in.offsetHeight : 0; });
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
    function tick(){
      var vh = window.innerHeight;
      chaps.forEach(function(ch){
        var r = ch.getBoundingClientRect(), total = ch.offsetHeight - vh;
        var p = clamp(-r.top / total); ch._p = p;
        var track = ch.querySelector('.track'); if (track) track.style.setProperty('--p', p.toFixed(3));
        var markCol = ch.querySelector('.mark-col'); if (markCol) markCol.classList.toggle('on', p > 0.04 && p < 0.98);
        var ws = ch._words, n = ws.length, hp = clamp((p - 0.02) / 0.20);
        for (var i = 0; i < n; i++){ var v = clamp(hp * n - i); ws[i].style.opacity = v; ws[i].style.transform = v >= 1 ? 'none' : ('translateY(' + ((1 - v) * 22) + 'px)'); }
        var u = ch._units, m = u.length;
        for (var j = 0; j < m; j++){
          var start = 0.26 + j * (0.58 / Math.max(m, 1));
          var lp = clamp((p - start) / 0.12);
          u[j].style.opacity = lp; u[j].style.transform = 'translateY(' + ((1 - lp) * 24) + 'px)';
        }
        if (ch._in){
          var room = vh - hdr, H = ch._h, shift = 0;
          if (H > room - PAD * 2){
            var natural = hdr + (room - H) / 2;              // where the flex centring puts it
            var gp = clamp((p - 0.18) / 0.7), ge = gp * gp * (3 - 2 * gp);
            shift = hdr + PAD + (room - PAD * 2 - H) * ge - natural;
          }
          ch._in.style.transform = shift ? 'translateY(' + shift.toFixed(1) + 'px)' : '';
        }
      });
      if (side && chaps.length){
        var p0 = chaps[0]._p || 0, rp = clamp((p0 - 0.01) / 0.26), re = 1 - Math.pow(1 - rp, 3);
        sBox.style.clipPath = 'inset(' + ((1 - re) * 100).toFixed(2) + '% 0 0 0)';
        var str = story.getBoundingClientRect(), sp = clamp(-str.top / Math.max(1, story.offsetHeight - vh));
        if (sImg) sImg.style.transform = 'translateY(' + ((1 - re) * 8).toFixed(2) + '%) scale(' + (1.08 - 0.08 * sp).toFixed(4) + ')';
        if (sCap) sCap.style.opacity = clamp((p0 - 0.22) / 0.12);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function boot(){ document.querySelectorAll('.about-root').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
